import React, { useState, useEffect } from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Button from "common/components/CustomButtons/Button.jsx";
import { withRouter } from "react-router";

import { Link } from "react-router-dom";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import EditIcon from "@material-ui/icons/Edit";
import { useSelector } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";

import config from "config.js";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
const importedStyle = dashboardStyle;
const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: { ...importedStyle.cardTitle, margin: "30px", padding: "20px" },
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
  ...regularFormsStyle,
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px",
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  inputAdornment: {
    position: "relative",
  },
  errorMessage: {
    color: "red",
  },
  label: {
    color: "black",
  },
  contactInfo: {
    margin: "20px",
  },
  checkboxAndRadio: {
    margin: "20px",
  },
  buttonStyle: {
    margin: "20px",
  },
};

function ReviewContract(props) {
  const ids = useSelector((state) => state.services.ids);
  const jrr = useSelector((state) => state.services.api.JRR);
  const { classes, mainPanelRef } = props;
  const [padHeight, setPadHeight] = useState((window.innerHeight * 3) / 4);
  const [padWidth, setPadWidth] = useState(window.innerWidth * 0.5);

  useEffect(() => {
    function handleResizeEvent() {
      setPadHeight((window.innerHeight * 2) / 4);
      setPadWidth(window.innerWidth * 0.5);
    }
    window.addEventListener("resize", handleResizeEvent);
    if (mainPanelRef != null) {
      mainPanelRef.scrollTop = 0;
    }
    return () => {
      window.removeEventListener("resize", handleResizeEvent);
    };
  }, [mainPanelRef]);

  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={10}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <EditIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Download Agreement</h4>
          </CardHeader>
          <CardBody>
            <GridContainer align="center">
              <GridItem xs={12}>
                <div className={classes.contactInfo}>
                  <h5>Here's a copy of your agreement</h5>
                </div>
              </GridItem>

              <GridItem xs={12}>
                <iframe
                  height={padHeight}
                  width={padWidth}
                  src={
                    config.API.ADDRESS +
                    `?target=user.${ids.user}/agreementview.${props.tempContractId}&x-omicron=${jrr}`
                  }
                  title="Agreement preview"
                />
                <br /> <br />
              </GridItem>
              <GridItem xs={12}>
                <Link to={config.MYACCOUNT.APP_PATH}>
                  <Button className={classes.buttonStyle} color="success">
                    Go to Main Screen
                  </Button>
                </Link>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

export default withStyles(styles)(withRouter(ReviewContract));
